<template>
  <v-form v-bind="this.$attrs">
    <v-row>
      <v-col class="d-flex justify-space-between" cols="12" md="10">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field placeholder="Số điện thoại" v-model="phone" clearable flat outlined dense hide-details />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field placeholder="Họ tên PHHS" v-model="buyerName" clearable flat outlined dense hide-details />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field placeholder="Email" v-model="email" clearable flat outlined dense hide-details />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="2">
        <v-btn color="primary" height="40px" width="100%" outlined @click="onFilterChanged"> Tìm kiếm </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="10">
        <v-row>
          <v-col class="pb-0" cols="12" md="4">
            <v-select
              clearable
              flat
              outlined
              dense
              hide-details
              placeholder="Hình thức học"
              :items="studentLearningMethodOptions"
              item-text="value"
              item-value="key"
              v-model="studentLearningMethods"
            />
          </v-col>
          <v-col class="pb-0" cols="12" md="4">
            <v-select
              clearable
              flat
              outlined
              dense
              hide-details
              placeholder="Khoá học muốn tham gia"
              :items="studentProductOptions"
              item-text="value"
              item-value="key"
              v-model="studentProducts"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              clearable
              flat
              outlined
              dense
              hide-details
              placeholder="Cơ sở đăng ký"
              :items="studentDepartmentOptions"
              item-text="value"
              item-value="key"
              v-model="studentDepartments"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="mt-4">
      <v-col class="d-flex justify-space-between" cols="12" md="10">
        <v-row>
          <v-col class="pb-0" cols="12" md="4">
            <v-text-field
              v-model="studentNameSearchField"
              placeholder="Tên học sinh"
              clearable
              flat
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              clearable
              flat
              outlined
              dense
              hide-details
              placeholder="Nguồn marketing"
              :items="LEAD_IMPORT_ORIGIN_OPTIONS"
              v-model="importOrigin"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              placeholder="Người chịu trách nhiệm"
              v-model="inCharge"
              :items="formattedUsers"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="d-flex justify-space-between" cols="12" md="10">
        <v-row>
          <v-col cols="12" md="4">
            <v-select
              v-if="advancedFilter"
              item-text="title"
              item-value="value"
              placeholder="Phân khúc"
              v-model="segment"
              :items="segmentOptions"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-if="advancedFilter"
              item-text="title"
              item-value="value"
              placeholder="Sản phẩm quan tâm"
              v-model="product"
              :items="formattedProducts"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-if="advancedFilter"
              item-text="title"
              item-value="value"
              v-model="interest"
              placeholder="Mức độ quan tâm"
              :items="interestOptions"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="2">
        <v-btn color="primary" height="40px" width="100%" @click="advancedFilter = !advancedFilter" text>
          Nâng cao <v-icon v-if="!advancedFilter">mdi-chevron-down</v-icon
          ><v-icon v-if="advancedFilter">mdi-chevron-up</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="advancedFilter">
      <v-col class="d-flex justify-space-between" cols="12" md="10">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="studentSchoolSearchField"
              placeholder="Trường đang học"
              clearable
              flat
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="expectSchoolSearchField"
              clearable
              flat
              outlined
              dense
              hide-details
              placeholder="Trường dự định thi vào"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="advancedFilter">
      <v-col class="d-flex justify-space-between" cols="12" md="10">
        <v-row>
          <v-col cols="12" md="4">
            <v-select
              item-text="title"
              item-value="value"
              placeholder="Năm học"
              :items="schoolYears"
              v-model="selectedSchoolYear"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import eleSchool from '@/assets/ele_school.json'
import secondarySchool from '@/assets/secondary_school.json'
import highSchool from '@/assets/high_school.json'
import utils from '@/plugins/utils'
import { mapGetters } from 'vuex'
import { CONFIG_KEYS, LEAD_IMPORT_ORIGIN_OPTIONS } from './helpers'
import get from 'lodash-es/get'

export default {
  computed: {
    ...mapGetters({ products: 'product/products', configs: 'leadConfig/configs' }),
    formattedProducts() {
      return this.products.map(p => ({ title: p.title, value: p.id }))
    },
    formattedUsers() {
      return this.users.map(u => ({ text: u.name ? u.name : u.username, value: u.id }))
    },
    studentLearningMethodOptions() {
      const config = this.configs.find(c => c.key === CONFIG_KEYS.STUDENT_LEARNING_METHOD)
      return get(config, 'value', [])
    },
    studentProductOptions() {
      const config = this.configs.find(c => c.key === CONFIG_KEYS.STUDENT_PRODUCT)
      return get(config, 'value', [])
    },
    studentDepartmentOptions() {
      const config = this.configs.find(c => c.key === CONFIG_KEYS.STUDENT_DEPARTMENT)
      return get(config, 'value', [])
    },
  },
  props: {
    users: Array,
  },
  data() {
    return {
      LEAD_IMPORT_ORIGIN_OPTIONS,
      //
      advancedFilter: false,
      show: false,
      phone: '',
      buyerName: '',
      email: '',
      studentNameSearchField: '',
      studentClassSearchField: '',
      studentSchoolSearchField: '',
      expectSchoolSearchField: '',
      type: '',
      product: [],
      inCharge: [],
      importOrigin: '',
      studentExpectation: '',
      selectedSchoolYear: '2023-2024',
      segment: {},
      interest: {},
      segmentOptions: [
        { title: 'Phổ thông', value: 'intermediate' },
        { title: 'Cao cấp', value: 'advance' },
      ],
      interestOptions: [
        { title: 'Thấp', value: 'cold' },
        { title: 'Vừa', value: 'warm' },
        { title: 'Cao', value: 'hot' },
      ],
      schoolOptions: [...eleSchool, ...secondarySchool, ...highSchool],
      // TODO: get school-year from server instead
      schoolYears: [{ title: 'Năm học 2023-2024', value: '2023-2024' }],
      studentLearningMethods: '',
      studentProducts: '',
      studentDepartments: '',
    }
  },
  methods: {
    onFilterChanged() {
      let query = {
        phone_contains: this.phone,
        buyerName_contains: this.buyerName,
        email_contains: this.email,
        products: this.product,
        inCharge: this.inCharge,
        studentNameSearchField_contains: this.studentNameSearchField
          ? utils.removeUnicode(this.studentNameSearchField)
          : '',
        studentSchoolSearchField_contains: this.studentSchoolSearchField
          ? utils.removeUnicode(this.studentSchoolSearchField)
          : '',
        studentClassSearchField_contains: this.studentClassSearchField
          ? utils.removeUnicode(this.studentClassSearchField)
          : '',
        studentExpectSchoolSearchField_contains: this.expectSchoolSearchField
          ? utils.removeUnicode(this.expectSchoolSearchField)
          : '',
        importOrigin_contains: this.importOrigin,
        interest: this.interest,
        segment: this.segment,
        studentLearningMethods: this.studentLearningMethods,
        studentProducts: this.studentProducts,
        studentDepartments: this.studentDepartments,
      }

      this.$emit('onFilterChanged', query)
    },
  },
}
</script>
